export default __webpack_public_path__ + "static/media/Payment.81ae0eea.png";